import ManageMyCards from '@src/pages/ticketRestaurant/manageMyCards/index';

const ManageGiftCards = () => {
  return <ManageMyCards isMarket={true} />;
};

export default ManageGiftCards;
